import { ApisauceInstance } from 'apisauce'

export class MediasAPI {
  private readonly api: ApisauceInstance

  constructor(api: ApisauceInstance) {
    this.api = api
  }

  async fetchToken(): Promise<string> {
    const response = await this.api.get<{ token: string }>('profiles/file_token/')
    if (!response.ok || !response.data?.token) {
      throw new Error('Failed to fetch media token')
    }
    return response.data.token
  }
}
